const blog = {
  hero: {
    eyebrow: "Аналитика и инсайты",
    title0:  "Блог о недвижимости",
    title1:  "в Дубае",
    sub:     "Аналитика рынка, инвестиционные стратегии и юридические гайды от старших консультантов ProNet — чтобы вы покупали, инвестировали и зарабатывали в Дубае.",
  },
  search: {
    placeholder: "Поиск статей…",
    label:       "Поиск статей",
    noResults:   "Статьи не найдены",
    noResultsSub:"Попробуйте другой запрос или выберите другую категорию.",
    clearFilters:"Сбросить фильтры",
  },
  filter: {
    all:   "Все",
    label: "Фильтр по категории",
  },
  card: {
    read: "Читать статью",
  },
  loading: "Загрузка статей…",
  featured: "Главная статья",
  toc:      "Содержание",
  share:    "Поделиться",
  tags:     "Теги статьи",
  faq: {
    eyebrow: "FAQ",
    title0:  "Часто задаваемые",
    title1:  "вопросы",
  },
  related: {
    eyebrow: "Читать далее",
    title0:  "Похожие",
    title1:  "статьи",
  },
  cta: {
    eyebrow:  "Бесплатная консультация",
    title0:   "Готовы инвестировать в",
    title1:   "недвижимость Дубая?",
    sub:      "Поговорите с одним из наших старших консультантов. Мы проанализируем ваши цели, бюджет и сроки — и подберём подходящий объект.",
    whatsapp: "Написать в WhatsApp →",
    message:  "Отправить сообщение",
  },
  sidebar: {
    ctaLabel:   "Бесплатная консультация",
    ctaText:    "Поговорите со специалистом по недвижимости Дубая. Подберём оптимальный вариант под ваши цели.",
    whatsapp:   "Написать в WhatsApp →",
    message:    "Или отправить сообщение",
  },
  postCta: {
    eyebrow:  "Готовы инвестировать?",
    title0:   "Запишитесь на бесплатную",
    title1:   "консультацию",
    sub:      "Наши старшие консультанты помогли сотням международных инвесторов купить, арендовать и приумножить портфель в Дубае. Поможем и вам.",
    whatsapp: "Написать в WhatsApp →",
    browse:   "Смотреть объекты",
  },
  sticky: "Получить консультацию",
  minRead: "мин. чтения",
  updated: "Обновлено",
};

export default blog;
